// SPDX-License-Identifier: MIT
/**
 * Product interfaces for brand films (`kit.ui`): tokens derived from the brand, controls, frames,
 * data components and interface motion. Library scenes and custom scenes share it. Truth rule:
 * numbers and claims on an interface come from the brand pack; content without a source is drawn
 * as skeleton bars, never as invented names or figures.
 */
export * from './chrome.ts';
export * from './controls.ts';
export * from './data.ts';
export * from './draw.ts';
export * from './motion.ts';
export * from './tokens.ts';
